// import { sortableHandle } from 'react-sortable-hoc';

import React from 'react';
import { Input, Form, Popover, Button } from 'antd';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import { WIDGET_GANTT_CHART_STATUS } from '@utils/enums';

import '../index.scss';

function GanttCombCell(formItemInfo) {
  const DragHandle = () => {
    const { attributes, listeners, setNodeRef, transform } = useDraggable({
      id: formItemInfo.record.id,
    });

    const style = transform
      ? {
          transform: CSS.Translate.toString(transform),
        }
      : undefined;

    return (
      <div
        ref={setNodeRef}
        style={style}
        {...attributes}
        {...listeners}
        className="drag-handle"
      >
        <span className="appkiticon icon-menu-outline" />
      </div>
    );
  };

  const popoverContent = (record) => (
    <div className="popover-content">
      <Button
        kind="transparent"
        onClick={() => {
          formItemInfo.handleAdd(true, formItemInfo.record.id);
        }}
      >
        Add new Parent Activity / Milestone
      </Button>
      {record.type === WIDGET_GANTT_CHART_STATUS.ACTIVITY ? (
        <Button
          kind="transparent"
          onClick={() => {
            formItemInfo.handleAdd(false, formItemInfo.record.id);
          }}
        >
          Add new Supporting Activity / Milestone
        </Button>
      ) : null}
    </div>
  );

  return (
    <div
      className="gantt-comb-cell"
      style={formItemInfo.record.isParent ? {} : { marginLeft: 60 }}
    >
      <DragHandle />
      {formItemInfo.record.isParent ? (
        <Popover
          content={popoverContent(formItemInfo.record)}
          trigger="click"
          overlayClassName="gantt-add-button-popover"
          placement="bottomLeft"
        >
          <div className="add-button">
            <span className="appkiticon icon-plus-fill" />
          </div>
        </Popover>
      ) : null}
      <Form.Item
        required={formItemInfo.required}
        name={formItemInfo.name}
        label={formItemInfo.label}
        rules={formItemInfo.rules}
        className={formItemInfo.className}
        style={formItemInfo.formItemStyle}
      >
        <Input
          style={{ background: 'transparent' }}
          placeholder="Please input"
          autoComplete="off"
          {...formItemInfo.compProps}
        />
      </Form.Item>
    </div>
  );
}

export default GanttCombCell;
